import { render } from "./ZillaParishad.vue?vue&type=template&id=c9f916a0&scoped=true"
import script from "./ZillaParishad.vue?vue&type=script&lang=js"
export * from "./ZillaParishad.vue?vue&type=script&lang=js"

import "./ZillaParishad.vue?vue&type=style&index=0&id=c9f916a0&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9f916a0"]])

export default __exports__